<div class="premium-modal-wrapper">
  <ion-header class="ion-no-border premium-header">
    <div class="header-curve"></div>
    <div class="custom-toolbar">
      <div class="toolbar-content">
        <div class="icon-btn" (click)="close()">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </div>
        <div class="title-group">
          <div class="title-main" *ngIf="trabajo">Galería #{{ trabajo.id }}</div>
          <div class="title-sub">Evidencia visual del trabajo</div>
        </div>
        <div class="icon-btn" style="visibility: hidden;">
          <ion-icon name="close"></ion-icon>
        </div>
      </div>
    </div>
  </ion-header>

  <ion-toolbar class="segment-toolbar ion-no-border">
    <ion-segment (ionChange)="segmentChanged($event)" [value]="segment" scrollable mode="ios" class="premium-segment">
      <ion-segment-button value="GENERAL">
        <ion-label>General</ion-label>
      </ion-segment-button>
      <ion-segment-button value="ANTES">
        <ion-label>Antes</ion-label>
      </ion-segment-button>
      <ion-segment-button value="DESPUES">
        <ion-label>Después</ion-label>
      </ion-segment-button>
    </ion-segment>
  </ion-toolbar>

  <ion-content class="content-bg" [fullscreen]="false">
    <div class="ion-padding">

    <!-- Empty State -->
    <div *ngIf="filteredDetails.length === 0" class="empty-state">
      <ion-icon name="albums-outline"></ion-icon>
      <p>No hay registros en esta sección</p>
    </div>

    <!-- Mosaico de Galería Premium -->
    <div class="gallery-mosaic fade-in">
      <div *ngFor="let d of filteredDetails" class="image-wrapper" (click)="viewImage(d, '')">
        <div class="img-container-mosaic">
          <!-- Usamos el pipe imageAuth para cargar la imagen con seguridad -->
          <ng-container *ngIf="d.imagen_path | imageAuth:getImagePath(d.source) | async as imageSrc; else loadingImage">
            <img [src]="imageSrc" alt="Foto" class="mosaic-img" />
            
            <!-- Badge de origen (Inspección/Medida) -->
            <div *ngIf="d.source !== 'galeria'" class="source-badge-mini" [class.medida]="d.source === 'medida'">
              <ion-icon [name]="d.source === 'inspeccion' ? 'eye-outline' : 'resize-outline'"></ion-icon>
            </div>

            <!-- Información Flotante (Fecha y Texto) -->
            <div class="image-info-overlay">
              <span class="date-tag">{{d.fecha | date:'dd/MM HH:mm'}}</span>
              <p class="caption-tag" *ngIf="d.texto">{{d.texto}}</p>
            </div>

            <!-- Botón Opciones Flotante -->
            <div class="options-trigger" *ngIf="d.source === 'galeria'" (click)="openOptions(d); $event.stopPropagation()">
              <ion-icon name="ellipsis-vertical"></ion-icon>
            </div>
          </ng-container>

          <ng-template #loadingImage>
            <div class="loading-placeholder">
              <ion-spinner name="crescent" color="primary"></ion-spinner>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

  </div>

  <ion-fab vertical="bottom" horizontal="end" slot="fixed">
    <ion-fab-button (click)="addPhoto()" class="fab-btn premium-fab">
      <ion-icon name="camera"></ion-icon>
    </ion-fab-button>
  </ion-fab>

</ion-content>
</div>
